import React from "react";
import warningTriangleRed from "@src/assets/svg/warning-triangle-red.svg";
import closeIcon from "@src/assets/svg/close-icon-white.svg";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import styles from "./ota-error-box.module.scss";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import { useOtaErrorBox } from "./use-ota-error-box";

const cssClassName = "ota-error-box";

interface OtaErrorBoxProps {
  activeInstallationData: ActiveInstallationProcessPayload | null;
  onClose: () => void;
}

const OtaErrorBox = ({ activeInstallationData, onClose }: OtaErrorBoxProps) => {
  const { texts, handleClose } = useOtaErrorBox({
    activeInstallationData,
    onClose,
  });

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={warningTriangleRed}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.titleHasItemName ? (
              <>
                {texts.titlePrefixBefore}
                <span
                  className={styles[`${cssClassName}__title-item-name`]}
                  title={texts.itemName}
                >
                  {texts.itemName}
                </span>
                {texts.titlePrefixAfter}
              </>
            ) : (
              texts.title
            )}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {texts.description}
          </span>
        </div>
      </div>

      <div className={styles[`${cssClassName}__close-button`]}>
        <IconButton
          fun={handleClose}
          icon={closeIcon}
          variant={["no-padding", "edit-save-close-icon"]}
        />
      </div>
    </div>
  );
};

export default OtaErrorBox;
